var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5218",
    "data-name": "Group 5218",
    transform: "translate(-1786 -245)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6254",
    "data-name": "Path 6254",
    d: "M562.517,1203.793a14,14,0,1,0,14,14A14,14,0,0,0,562.517,1203.793Zm8.326,8.1c-2.122,2.012-6.891,6.536-7.591,7.236-.014.018-.029.035-.044.052a1.243,1.243,0,0,1-1.756.084c-.4-.334-4.224-4.012-7.7-7.372Zm-17.855.747c1.419,1.372,3.958,3.824,5.743,5.529l-5.743,5.533Zm.7,11.868,5.812-5.6c.693.659,1.109,1.045,1.235,1.151a2.431,2.431,0,0,0,1.547.576,2.457,2.457,0,0,0,1.744-.775h0c.14-.139.46-.449.977-.943l5.806,5.591Zm17.911-.725-5.82-5.607h0c1.762-1.684,4.362-4.152,5.819-5.534Z",
    transform: "translate(1237.483 -958.793)",
    fill: "#0a7da7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.db5d140f6f0421c8935466e6264f3e1b.svg";
export { ForwardRef as ReactComponent };